import { ReactElement, ReactNode } from 'react';
import { Backdrop, Fade, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

// Styles
import styles from './index.module.scss';

// Hooks

// Store + Core
import { closeModal } from 'store/modal/actions';
import { isModalOpenSelector } from 'store/modal/selectors';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';
import { PARSAction } from 'core/models';
import { ModalFlexContainer } from 'hooks/StyledComponents';

// Types
interface IProps {
  children?: ReactNode;
  errorMessage?: string;
  isOpen: boolean;
  onClose?(): void;
  title?: string;
}

export const Modal = (props: IProps): ReactElement => {
  const { children, isOpen, errorMessage, onClose, title } = props;
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();
  const isReduxModalOpen: boolean = useSelector(isModalOpenSelector);

  const handleClose = (): void => {
    // Redux: close modal.
    dispatch(closeModal());

    // Optional callback.
    onClose?.();
  };

  return (
    <ModalFlexContainer
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isReduxModalOpen || isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div className={styles.wrapper}>
          {/* Error message */}
          {errorMessage && <div className={styles.error}>{errorMessage}</div>}

          {/* Header content */}
          <div className={styles.header}>
            {title && <h2 id="transition-modal-title">{title}</h2>}
            <IconButton className={styles.close} title="Close" onClick={handleClose} size="large">
              <Close />
            </IconButton>
          </div>

          {/* Main content */}
          <div className={styles['content-wrapper']}>{children}</div>
        </div>
      </Fade>
    </ModalFlexContainer>
  );
};
